import {Article, MapPoints} from "./article";

export class PointData {
    art: Article = new Article();
    point: MapPoints = new MapPoints();
    constructor(data?: PointData) {
        this.art = data?.art ?? new Article();
        this.point = data?.point ?? new MapPoints();
    }
}


export class EventType {
    key: string = '';
    title: string = '';

    constructor(data?: EventType) {
        this.key = data?.key ?? ''
        this.title = data?.title ?? '';
    }
}

export const eventTypes = [
    {
       key: 'MEDAL',
       title: 'Боевой подвиг',
    },
    {
       key: 'TARGET',
       title: 'Боевые действия',
    },
    {
       key: 'BOMB',
       title: 'Бомбардировки',
    },
    {
       key: 'FIST',
       title: 'Будни ЖД',
    },
    {
       key: 'GEAR',
       title: 'Восстановительный поезд',
    },
    {
       key: 'HELMET',
       title: 'Колонны особого резерва',
    },
    {
       key: 'ATTENTION',
       title: 'Нарушения в работе',
    },
    {
       key: 'CRANE',
       title: 'Развитие инфраструктуры',
    },
    {
       key: 'ASHOKA',
       title: 'Спец.вагоны',
    },
    {
       key: 'TRAIN',
       title: 'Строительство бронепоезда',
    },
    {
       key: 'STAR',
       title: 'Трудовой подвиг',
    },
     {
       key: 'EVACUATION',
       title: 'Эвакуация',
    },
]